// Search helpers for the root and noun pickers: Devanagari, Hindi, English and plain Latin (padh → पढ) all match.

import { transliterate } from '@/prakrit/lib/grammar/translit'

const stripMarks = (value: string): string => value.normalize('NFD').replace(/[̀-ͯ]/g, '')

/** Latin key without diacritics: पढ → padha, णयर → nayara. */
export const latinKey = (text: string): string => stripMarks(transliterate(text)).toLowerCase()

/** One lowercase string to search in. */
export const searchText = (...parts: string[]): string => parts
    .map(p => p.normalize('NFC').toLowerCase())
    .join(' | ')

export const normaliseQuery = (query: string): { raw: string, latin: string } => {
    const raw = query.normalize('NFC').trim().toLowerCase()

    return { raw, latin: stripMarks(raw) }
}

export const matches = (haystack: string, query: { raw: string, latin: string }): boolean => {
    if (!query.raw) return true

    return haystack.includes(query.raw) || (query.latin !== '' && haystack.includes(query.latin))
}
